<script lang="ts">
import Vue from 'vue'
import DeleteButton from "@/components/ui/DeleteButton.vue";
import Button from "@/components/ui/Button.vue";
import BaseModal from "@/components/ui/BaseModal.vue";
import { deletePartner } from "@/api/partner";

export default Vue.extend({
    name: "DeletePartner",
    components: {BaseModal, Button, DeleteButton},
    props: ['id'],
    data() {
        return {
            visible: false,
        }
    },
    methods: {
        deletePartner(id) {
            deletePartner(id).then(response => {
                this.$message(response.data.message);
                this.visible = false;
                this.$emit('deleted')
            }).catch(error => {
                this.$message.error(error.response.data.message);
            })
        }
    },
})
</script>

<template>
<div class="delete-partner">
    <DeleteButton @click="visible = true"/>
    <BaseModal v-model="visible">
        <div class="w-100">
            <div class="title">Ви впевнені, що бажаєте видалити точку продажу?</div>
<!--            <div class="content">Цю дію неможливо скасувати.</div>-->
            <div class="footer">
                <button type="button" class="btn btn-primary w-100" @click="deletePartner(id)">Так, видалити</button>
                <button type="button" class="btn btn-light w-100" @click="visible = false">Повернутися назад</button>
            </div>
        </div>
    </BaseModal>
</div>
</template>

<style scoped lang="scss">
.delete-partner {
    .title {
        font-family: 'Geist', serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        /* identical to box height, or 117% */
        text-align: center;

        color: #09090B;


        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;

    }
    .content {
        margin-top: 26px;
        font-family: 'Geist',serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        /* or 125% */
        text-align: center;

        color: #9E9E9E;


        /* Inside auto layout */
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
    }
    .footer {
        margin-top: 40px;
        .btn {
            margin-bottom: 16px;
        }
        @media (min-width: 768px) {
            margin-top: 50px;
            display: flex;
            gap: 26px;
        }
    }
}
</style>
